/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PropTypes = require('prop-types');
var isRequiredOneOf = require('./isRequiredOneOf.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

const AriaLabelPropType = isRequiredOneOf["default"]({
  'aria-label': PropTypes__default["default"].string,
  'aria-labelledby': PropTypes__default["default"].string
});

exports.AriaLabelPropType = AriaLabelPropType;
